/**
 * DevExtreme (esm/ui/context_menu.js)
 * Version: 24.1.8
 * Build date: Mon Dec 16 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import ContextMenu from "../__internal/ui/context_menu/m_context_menu";
export default ContextMenu;
